import { render } from "./TraderForm.vue?vue&type=template&id=24cd7b84&ts=true"
import script from "./TraderForm.vue?vue&type=script&lang=ts"
export * from "./TraderForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__